import Checkbox from '@mui/material/Checkbox';
import { ChangeEventHandler, FocusEventHandler } from 'react';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';

export default function CheckboxField({
  name,
  onBlur,
  onChange,
  value,
  ...rest
}: CheckboxFieldProps) {
  return (
    <FieldWrapper {...rest} inlineLabel>
      <Checkbox
        checked={value}
        name={name}
        onBlur={onBlur as any}
        onChange={onChange}
      />
    </FieldWrapper>
  );
}

export interface CheckboxFieldProps extends FieldWrapperProps {
  name?: string;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: any;
}
